import PathwayDescription from './PathwayDescription';
import PropTypes from 'prop-types';
import CostsChart from './CostsChart';
import EmissionsChart from './EmissionsChart';
import LcaBreakdownContainer from './LcaBreakdownContainer';
import TeaBreakdownContainer from './TeaBreakdownContainer';
import EmissionsBreakdownTable from './EmissionsBreakdownTable';
import CostsBreakdownTable from './CostsBreakdownTable';
import AnalysisContainer from '../core/AnalysisContainer';
import AnalysisBox from '../core/AnalysisBox';
import EmissionsStackedBarChart from './EmissionsStackedBarChart';
import CostsStackedBarChart from './CostsStackedBarChart';

const ResultsSection = ({ pathwayTemplate }) => {
  return (
    <div className="mb-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 mb-8">
        <div className="lg:col-span-1">
          <div className="flex flex-col">
            <AnalysisContainer title="Emissions">
              <AnalysisBox>
                <EmissionsStackedBarChart />
              </AnalysisBox>
            </AnalysisContainer>

            <AnalysisContainer title="Costs">
              <AnalysisBox>
                <CostsStackedBarChart />
              </AnalysisBox>
            </AnalysisContainer>
          </div>
        </div>
        <div className="lg:col-span-1">
          <PathwayDescription pathway={pathwayTemplate} />
        </div>
        <div className="lg:col-span-1">
          <AnalysisContainer title="Emissions Analysis">
            <AnalysisBox>
              <EmissionsChart />
            </AnalysisBox>
          </AnalysisContainer>
        </div>
        <div className="lg:col-span-1">
          <AnalysisContainer title="Techno-Economic Analysis">
            <AnalysisBox>
              <CostsChart />
            </AnalysisBox>
          </AnalysisContainer>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-x-8">
        <AnalysisContainer title="Scope 3 Breakdown">
          <AnalysisBox>
            <LcaBreakdownContainer />
          </AnalysisBox>
        </AnalysisContainer>
        <AnalysisContainer title="Feedstock Breakdown">
          <AnalysisBox>
            <TeaBreakdownContainer />
          </AnalysisBox>
        </AnalysisContainer>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8">
        <EmissionsBreakdownTable />
        <CostsBreakdownTable />
      </div>
    </div>
  );
};

ResultsSection.propTypes = {
  pathwayTemplate: PropTypes.object,
};

export default ResultsSection;
